/* EMMA SANTINI: franja Trustpilot arriba del carrito lateral + boton CONTINUAR PAGO SEGURO con garantias debajo + ENVIO GRATIS en negro y mayusculas */
(function(){
  var CSS='.emma-tp{display:flex;align-items:center;justify-content:center;gap:10px;padding:12px 10px;background:#fff;border-bottom:1px solid #e5e5e5;font-family:inherit;color:#111;white-space:nowrap}'+
  '.emma-tp__logo{display:flex;align-items:center;gap:6px;font-weight:700;font-size:14px}'+
  '.emma-tp__logo svg{width:22px;height:22px;display:block}'+
  '.emma-tp__sep{width:1px;height:26px;background:#d5d5d5;flex:0 0 auto}'+
  '.emma-tp__rate{display:flex;align-items:center;gap:4px;font-weight:700;font-size:13px}'+
  '.emma-tp__rate span{color:#00b67a;font-size:13px;letter-spacing:1px}'+
  '.emma-tp__n{font-size:12px;color:#777}.emma-tp__n b{color:#111;font-weight:700;font-size:13px}'+
  '@media(max-width:420px){.emma-tp{gap:7px;padding:10px 6px}.emma-tp__logo{font-size:12px}.emma-tp__logo svg{width:18px;height:18px}.emma-tp__rate,.emma-tp__rate span,.emma-tp__n{font-size:11px}.emma-tp__n b{font-size:12px}}'+
  'html body #cart-drawer [data-essential-cart-element="cart-drawer-checkout-button"]{border-radius:999px!important;min-height:52px!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:.04em!important}'+
  'html body #cart-drawer [data-essential-cart-element="cart-drawer-checkout-button"] *{font-weight:700!important;text-transform:uppercase!important;letter-spacing:.04em!important}'+
  '.emma-gar{display:flex;align-items:center;justify-content:center;gap:12px;margin:10px 0 4px;font-size:11.5px;font-weight:600;color:#555;white-space:nowrap}'+
  '.emma-gar span{display:flex;align-items:center;gap:5px}.emma-gar svg{width:13px;height:13px;flex:0 0 auto}'+
  '.emma-gar i{width:1px;height:18px;background:#d5d5d5}'+
  '@media(max-width:380px){.emma-gar{gap:8px;font-size:10.5px}}';
  var HTML='<div class="emma-tp__logo"><svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" fill="#00b67a"/><path d="M12 4.2l2.1 5.7h5.9l-4.8 3.5 1.9 5.8L12 15.6 6.9 19.2l1.9-5.8L4 9.9h5.9z" fill="#fff"/></svg>Trustpilot</div><i class="emma-tp__sep"></i><div class="emma-tp__rate">4,9/5 <span>★★★★★</span></div><i class="emma-tp__sep"></i><div class="emma-tp__n"><b>89 045</b> ověřených nákupů</div>';
  var GAR='<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>Záruka vrácení peněz 30 dní</span><i></i><span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>100% bezpečná platba · šifrování SSL</span>';
  function style(){if(document.getElementById('emma-tp-css'))return;var s=document.createElement('style');s.id='emma-tp-css';s.textContent=CSS;document.head.appendChild(s)}
  function ship(d){
    var all=d.querySelectorAll('*');
    for(var i=0;i<all.length;i++){
      var n=all[i];
      if(n.children.length)continue;
      if(!/env[ií]o gratis|doprava zdarma|doprava zdarma|zdarma doprava|free shipping/i.test(n.textContent||''))continue;
      if(n.style.getPropertyValue('text-transform')!=='uppercase'){
        n.style.setProperty('text-transform','uppercase','important');
        n.style.setProperty('color','#000','important');
        n.style.setProperty('font-weight','700','important');
      }
    }
  }
  function put(){
    var d=document.getElementById('cart-drawer');if(!d)return;
    var a=d.querySelector('[data-essential-cart-element="announcement-wrapper"]');
    if(a&&a.parentNode){
      var e=d.querySelector('.emma-tp');
      if(!(e&&e.nextElementSibling===a)){
        if(e)e.remove();
        style();
        e=document.createElement('div');e.className='emma-tp';e.innerHTML=HTML;
        a.parentNode.insertBefore(e,a);
      }
    }
    var b=d.querySelector('[data-essential-cart-element="cart-drawer-checkout-button"]');
    if(b&&b.parentNode){
      var g=d.querySelector('.emma-gar');
      if(!(g&&g.previousElementSibling===b)){
        if(g)g.remove();
        style();
        g=document.createElement('div');g.className='emma-gar';g.innerHTML=GAR;
        b.parentNode.insertBefore(g,b.nextSibling);
      }
    }
    ship(d);
  }
  function start(){put();new MutationObserver(put).observe(document.body,{childList:true,subtree:true,characterData:true})}
  if(document.body)start();else document.addEventListener('DOMContentLoaded',start);
})();
